/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * NOTE(Quentin): This pattern should not be replicated. You can now specify None as action args
 * type. This is here to support legacy missions. @exclude
 */
export interface StopVideoActionArgs {
  /** Indicates no arguments for this action. */
  noArgs: boolean;
}

export interface StopVideoResultData {
}

export interface StopVideoActionStateData {
}

function createBaseStopVideoActionArgs(): StopVideoActionArgs {
  return { noArgs: false };
}

export const StopVideoActionArgs = {
  encode(message: StopVideoActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.noArgs === true) {
      writer.uint32(8).bool(message.noArgs);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StopVideoActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopVideoActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.noArgs = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopVideoActionArgs {
    return { noArgs: isSet(object.noArgs) ? globalThis.Boolean(object.noArgs) : false };
  },

  toJSON(message: StopVideoActionArgs): unknown {
    const obj: any = {};
    if (message.noArgs === true) {
      obj.noArgs = message.noArgs;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopVideoActionArgs>, I>>(base?: I): StopVideoActionArgs {
    return StopVideoActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopVideoActionArgs>, I>>(object: I): StopVideoActionArgs {
    const message = createBaseStopVideoActionArgs();
    message.noArgs = object.noArgs ?? false;
    return message;
  },
};

function createBaseStopVideoResultData(): StopVideoResultData {
  return {};
}

export const StopVideoResultData = {
  encode(_: StopVideoResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StopVideoResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopVideoResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): StopVideoResultData {
    return {};
  },

  toJSON(_: StopVideoResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StopVideoResultData>, I>>(base?: I): StopVideoResultData {
    return StopVideoResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopVideoResultData>, I>>(_: I): StopVideoResultData {
    const message = createBaseStopVideoResultData();
    return message;
  },
};

function createBaseStopVideoActionStateData(): StopVideoActionStateData {
  return {};
}

export const StopVideoActionStateData = {
  encode(_: StopVideoActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StopVideoActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopVideoActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): StopVideoActionStateData {
    return {};
  },

  toJSON(_: StopVideoActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StopVideoActionStateData>, I>>(base?: I): StopVideoActionStateData {
    return StopVideoActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopVideoActionStateData>, I>>(_: I): StopVideoActionStateData {
    const message = createBaseStopVideoActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
